import DataEntryModule from "lib/dataentry/DataEntryModule";
import HarvestExportModule from "lib/hex/HarvestExportModule";
import userStore from "data/userStore";
import { appAlert } from "lib/withOver";

class Router extends Backbone.Router {

    initialize(application){
        this.app = application;
        //@dataEntryModule = application.DataEntryModule
        this.dataQualityReportModule = application.DataQualityReportModule;
    }

    decider(path) {
        const canUseDE = userStore.canUseDE();
        const canUseDqr = userStore.canUseDqr();
        const canUseHex = userStore.canUseHex();
        if (!path) {
            path = "de";
        }

        //we have a path so lets route this correctly
        if (/^dqr/.test(path) && canUseDqr) {
            this.dataQualityReport(path);
        } else if (/^hex/.test(path) && canUseHex) {
            this.harvest(path);
        } else if (canUseDE) {
            this.dataentry(path);
        } else if (canUseHex) {
            window.location.hash = "hex";
        } else if (canUseDqr) {
            window.location.hash = "dqr";
        } else {
            appAlert("This user has no access to the application");
        }
    }

    dataentry(path) {
        this.dispatch("user:activity");

        if (!this.dataEntryModule) {
            this.dataEntryModule = new DataEntryModule({
                model: this.app.model,
                useDefaultSearch: true,
            });
            this.app.layout.de.show(this.dataEntryModule);
        }

        $("#content").removeClass("dqr").removeClass("hex").addClass("de");
        this.app.model.set("view", "de");

        //@dataEntryModule.start( @app )
        //after the module is started lets see if we need to preload any items
        if (path && (path.split("~").length >= 4)) {
            const maybeParseInt = function(v) {
                if (v != null) { return parseInt(v); } else { return v; }
            };
            // eslint-disable-next-line
            let [n, org, key, id, ekey, eid, shortname] = path.split("~");
            if (!shortname) {
                shortname = null;
            }
            this.dispatch("confirm:load:entity_data", org, key, maybeParseInt(id), ekey, maybeParseInt(eid), shortname, this.app.model);
        }
    }

    dataQualityReport() {
        this.dispatch("user:activity");
        $("#content").removeClass("de").removeClass("hex").addClass("dqr");
        this.app.model.set("view", "dqr");
        this.dataQualityReportModule.start(this.app);
    }

    harvest() {
        this.dispatch("user:activity");
        $("#content").removeClass("de").removeClass("dqr").addClass("hex");
        this.app.model.set("view", "hex");
        if (!this.hexModule) {
            this.hexModule = new HarvestExportModule({model: this.app.model.get("hex")});
            this.app.layout.hex.show(this.hexModule);
        }
    }
}

Router.prototype.routes = {
    "*path": "decider"
    // 'de*path': "dataentry"
    // 'dqr': "dataQualityReport"
    // 'new': "dataentry"
};

export default Router;



// WEBPACK FOOTER //
// ./app/lib/Router.js